import React, { forwardRef, ReactNode } from "react";
import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  useMultiStyleConfig,
} from "@chakra-ui/react";

interface Props extends CheckboxProps {
  children: ReactNode;
  variant?: string;
  name?: string;
  value?: any;
  errorMessage?: string;
  defaultValue?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(
  (
    { children, defaultValue, name, value, errorMessage, ...props },
    ref
  ): JSX.Element => {
    const styles = useMultiStyleConfig(`Checkbox`, props);

    return value ? (
      <ChakraCheckbox
        id={name}
        name={name}
        ref={ref}
        colorScheme="red"
        spacing={4}
        value={value}
        defaultValue={defaultValue}
        __css={styles}
        {...props}
      >
        {children}
      </ChakraCheckbox>
    ) : (
      <ChakraCheckbox
        id={name}
        name={name}
        ref={ref}
        colorScheme="red"
        spacing={4}
        __css={styles}
        {...props}
      >
        {children}
      </ChakraCheckbox>
    );
  }
);
export type { Props as CheckboxProps };
